<template>
  <div class="table-page-container">
    <!-- 筛选条件区域（核心：添加flex布局和响应式样式） -->
    <div class="search-form">
      <el-form 
        :inline="true" 
        :model="searchForm" 
        class="demo-form-inline search-form-content"
      >
        <!-- 设备名称筛选 -->
        <el-form-item label="设备名称" class="form-item">
          <el-input
            v-model="searchForm.deviceName"
            placeholder="请输入设备名称"
            clearable
            style="width: 180px;"
            @keyup.enter="handleSearch"
          />
        </el-form-item>
        <!-- 设备号筛选 -->
        <el-form-item label="设备号" class="form-item">
          <el-input
            v-model="searchForm.deviceNo"
            placeholder="请输入设备号"
            clearable
            style="width: 180px;"
            @keyup.enter="handleSearch"
          />
        </el-form-item>
        <!-- 点位地址筛选 -->
        <el-form-item label="点位地址" class="form-item">
          <el-input
            v-model="searchForm.address"
            placeholder="请输入点位地址"
            clearable
            style="width: 220px;"
            @keyup.enter="handleSearch"
          />
        </el-form-item>
        <!-- 设备状态筛选 -->
        <el-form-item label="设备状态" class="form-item">
          <el-select
            v-model="searchForm.deviceStatus"
            placeholder="请选择设备状态"
            clearable
            style="width: 140px;"
          >
            <el-option label="全部" value="" />
            <el-option label="隐藏" value="1" />
            <el-option label="离线" value="2" />
            <el-option label="在线" value="3" />
            <el-option label="故障" value="4" />
          </el-select>
        </el-form-item>
        <!-- 社区筛选 -->
        <!-- <el-form-item label="社区" class="form-item">
          <el-input
            v-model="searchForm.userName"
            placeholder="请输入社区名称"
            clearable
            style="width: 180px;"
            @keyup.enter="handleSearch"
          />
        </el-form-item> -->
        <!-- 创建时间筛选 -->
        <!-- <el-form-item label="创建时间" class="form-item">
          <el-date-picker
            v-model="searchForm.createTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            style="width: 280px;"
          />
        </el-form-item> -->
        <!-- 操作按钮组（单独类名，用于响应式布局） -->
        <el-form-item class="form-item btn-group">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <el-button type="success" @click="openEditDialog()">添加设备</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 设备列表表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%; margin-bottom: 20px;"
      v-loading="loading"
      highlight-current-row
    >
      <el-table-column prop="deviceName" label="设备名称" width="150" align="center" />
      <el-table-column prop="deviceNo" label="设备号" width="200" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.deviceNo }}</span>
          <el-button size="mini" type="text" @click.stop="openOrderDialog(scope.row)">查看订单</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="点位地址" min-width="200" align="center" />
      <el-table-column prop="deviceStatus" label="设备状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.deviceStatus === 4 ? 'danger' : scope.row.deviceStatus === 3 ? 'success' : 'warning'"
          >
            {{ 
              scope.row.deviceStatus === 1 ? '隐藏' : 
              scope.row.deviceStatus === 2 ? '离线' : 
              scope.row.deviceStatus === 3 ? '在线': '故障' 
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="usedCapacity" label="已用容量" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.usedCapacity }}
          <el-progress
            :percentage="scope.row.usedCapacity * 10"
            size="mini"
            style="width: 80px; margin-left: 5px;"
          />
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="200" align="center">
        <template slot-scope="scope">
          {{ formatTime(scope.row.createTime) }}
        </template>
      </el-table-column>
      <!-- 修复：补充列标签，显示街道-社区 -->
      <el-table-column label="街道-社区" width="200" align="center">
        <template slot-scope="scope">
          {{ scope.row.streetName || '' }}-{{ scope.row.communityName || '' }}
        </template>
      </el-table-column>
      <el-table-column label="地理坐标" width="200" align="center">
        <template slot-scope="scope">
          纬度：{{ scope.row.latitude || '-' }}<br/>
          经度：{{ scope.row.longitude || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click.stop="openEditDialog(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click.stop="handleDelete(scope.row)">删除</el-button>
          <el-button size="mini" type="text" @click.stop="toDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.pageNo"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
      style="text-align: right;"
    >
    </el-pagination>

    <!-- 图片预览弹窗、订单弹框、编辑弹框 -->
    <el-dialog title="设备图片预览" :visible.sync="previewVisible" width="500px">
      <img :src="previewImageUrl" style="width: 100%;" />
    </el-dialog>

    <el-dialog
      :title="`【${currentDevice.deviceName || '未知设备'}】桶内订单`"
      :visible.sync="orderDialogVisible"
      width="90%"
      top="20px"
      append-to-body
    >
      <div class="top-bar" style="padding: 16px 0; border-bottom: 1px solid #eee; margin-bottom: 20px;">
        <div class="filter-wrap">
          <!-- <span>按种类筛选：</span>
          <el-select
            v-model="orderFilterType"
            placeholder="全部种类"
            style="width: 180px;"
            @change="handleOrderFilter"
          >
            <el-option label="全部种类" value="" />
            <el-option label="可回收" value="可回收" />
            <el-option label="不可回收" value="不可回收" />
          </el-select> -->
        </div>
        <el-button
          type="primary"
          plain
          @click="toggleBigMode"
        >
          切换{{ isBigMode ? '列表' : '大图' }}模式
        </el-button>
      </div>

      <div
        class="order-list"
        :class="{ 'big-mode': isBigMode }"
        v-loading="orderLoading"
      >
        <div
          class="order-card"
          v-for="(order, index) in filteredOrders"
          :key="order.id || index"
        >
          <div class="order-time">
            <i class="el-icon-time" style="margin-right: 4px;"></i>
            {{ formatTime(order.createTime) }}
          </div>
          <img 
            v-if="order.insidePicUrl" 
            :src="order.insidePicUrl" 
            style="width: 120px; height: 80px; border-radius: 4px; margin-bottom: 16px;"
            alt="订单图片"
            @click="previewOrderImage(order.insidePicUrl)"
          >
          <div v-else class="order-img-placeholder"></div>
          <div class="order-info-row">
            <div class="info-item">
              <i class="el-icon-s-data" style="margin-right: 4px;"></i>
              回收重量: {{ order.weight }}kg
            </div>
            <div class="info-item">
              <i class="el-icon-menu" style="margin-right: 4px;"></i>
              回收种类: 可回收物
            </div>
            <div class="info-item">
              <i class="el-icon-money" style="margin-right: 4px;"></i>
              回收金额: ¥{{ order.totalPrice }}
            </div>
            <div class="info-item">
              <i class="el-icon-user" style="margin-right: 4px;"></i>
              回收卡号: {{ order.orderNo }}
            </div>
          </div>
          <div class="order-info-row">
            <div class="info-item">
              <i class="el-icon-phone" style="margin-right: 4px;"></i>
              联系电话: {{ order.phone || '-' }}
            </div>
            <div class="info-item">
              <i class="el-icon-location" style="margin-right: 4px;"></i>
              回收站点: {{ currentDevice.deviceNo }}（{{ currentDevice.address }}）
            </div>
          </div>
        </div>
        <div v-if="filteredOrders.length === 0 && !orderLoading" class="empty-order">
          <el-empty description="暂无桶内订单数据"></el-empty>
        </div>
      </div>

      <!-- <el-pagination
        @size-change="handleOrderSizeChange"
        @current-change="handleOrderCurrentChange"
        :current-page="orderPagination.pageNo"
        :page-sizes="[10, 20, 50]"
        :page-size="orderPagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="orderPagination.total"
        style="text-align: right; margin-top: 20px;"
      >
      </el-pagination> -->
    </el-dialog>

    <el-dialog title="订单图片预览" :visible.sync="orderImageVisible" width="500px">
      <img :src="orderImageUrl" style="width: 100%;" />
    </el-dialog>

    <el-dialog 
      :title="editDialogTitle" 
      :visible.sync="editDialogVisible" 
      width="700px" 
      append-to-body 
      @close="resetEditForm"
    >
      <el-form 
        :model="editForm" 
        :rules="editRules" 
        ref="editFormRef" 
        label-width="120px" 
        style="margin-top: 20px;"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="设备名称" prop="deviceName">
              <el-input v-model="editForm.deviceName" placeholder="请输入设备名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备号" prop="deviceNo">
              <el-input v-model="editForm.deviceNo" placeholder="请输入设备号" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备状态" prop="deviceStatus">
              <el-select v-model="editForm.deviceStatus" placeholder="请选择设备状态">
                <el-option label="隐藏" value="1" />
                <el-option label="离线" value="2" />
                <el-option label="在线" value="3" />
                <el-option label="故障" value="4" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="已用容量" prop="usedCapacity">
              <el-input-number v-model="editForm.usedCapacity" :min="0" :max="10" placeholder="0-10之间" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经度" prop="longitude">
              <el-input v-model="editForm.longitude" placeholder="请输入经度" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度" prop="latitude">
              <el-input v-model="editForm.latitude" placeholder="请输入纬度" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="所属街道">
              <el-select v-model="editForm.wlStreetId" placeholder="请选择街道" @change="getCommunityList">
                <el-option
                  v-for="item in communityNameArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="所属社区">
              <el-select
                v-model="editForm.wlCommunityId"
                placeholder="请选择工作社区"
              >
                <el-option
                  v-for="item in residentialQuartersArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="设备图片">
              <el-upload
                action
                list-type="picture-card"
                :before-upload="beforeUpload"
                :file-list="editForm.picUrlList"
                :limit="1"
                :on-exceed="surpass"
                :http-request="importFile"
                :on-remove="staffImgRemove"
                :on-preview="handlePictureCardPreview"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEditForm"  :disabled="submitStaffBtnBool">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment';
// 修复：引入lodash（如果项目未安装，先执行 npm install lodash --save）
import _ from 'lodash';
import { 
  getWlRecycleDeviceList, 
  getWlRecycleDeviceOrder,
  addWlRecycleDevice,
  editWlRecycleDevice,
  deleteWlRecycleDevice,
  getStreet,
  getCommunity
} from "@/api/recyclingMachine";
import { uploadAction } from "@/api/manage"

export default {
  name: "RecyclingMachineList",
  data() {
    return {
      loading: false,
      tableData: [],
      previewVisible: false,
      previewImageUrl: '',
      searchForm: {
        deviceName: '',
        deviceNo: '',
        address: '',
        deviceStatus: '',
        createTime: []
      },
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      orderDialogVisible: false,
      currentDevice: {},
      orderLoading: false,
      orderList: [],
      orderFilterType: '',
      isBigMode: false,
      orderPagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      orderImageVisible: false,
      orderImageUrl: '',
      editDialogVisible: false,
      editDialogTitle: '',
      editForm: {
        id: '',
        deviceName: '',
        deviceNo: '',
        deviceStatus: '',
        usedCapacity: 0,
        userName: '',
        longitude: '',
        latitude: '',
        wlStreetId: '',
        wlCommunityId: '',
        picUrl: '',
        picUrlList: []
      },
      // 修复：删除userName校验规则（因表单中已注释该字段）
      editRules: {
        deviceName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        deviceNo: [{ required: true, message: '请输入设备号', trigger: 'blur' }],
        address: [{ required: true, message: '请输入点位地址', trigger: 'blur' }],
        deviceStatus: [{ required: true, message: '请选择设备状态', trigger: 'change' }],
        usedCapacity: [{ required: true, message: '请输入已用容量', trigger: 'blur' }]
      },
      uploadHeaders: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      residentialQuartersArr: [],
      communityNameArr: [],
      communityResAll: [],
      submitStaffBtnBool: false,
      url: {
        upload: '/file/upload'
      },
      dialogVisible: false,
      dialogImageUrl: ''
    };
  },
  // 修复：created改为async函数，支持await
  async created() {
    try {
      // 获取街道列表
      const streetRes = await getStreet();
      this.communityNameArr = streetRes.data || [];
      // 获取全量社区列表（优化：传递空参数避免接口报错）
      const communityRes = await getCommunity({});
      this.communityResAll = communityRes.data || [];
    } catch (error) {
      console.error('初始化街道/社区数据失败：', error);
      this.$message.warning('街道/社区数据加载失败，请刷新页面');
    }
    this.getTableData();
  },
  computed: {
    filteredOrders() {
      if (!this.orderFilterType) return this.orderList;
      return this.orderList.filter(item => item.type === this.orderFilterType);
    }
  },
  methods: {
    formatTime(time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-';
    },
    previewImage(url) {
      if (!url) {
        this.$message.warning('暂无设备图片');
        return;
      }
      this.previewImageUrl = url;
      this.previewVisible = true;
    },
    async getTableData() {
      this.loading = true;
      try {
        const params = {
          ...this.pagination,
          deviceName: this.searchForm.deviceName,
          deviceNo: this.searchForm.deviceNo,
          address: this.searchForm.address,
          deviceStatus: this.searchForm.deviceStatus,
          userName: this.searchForm.userName
        };
        const res = await getWlRecycleDeviceList(params);
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          // 修复：map添加参数，修正this指向和数据读取逻辑
          this.tableData = this.tableData.map(item => {
            // 匹配社区名称
            if (!_.isEmpty(this.communityResAll)) {
              const community = this.communityResAll.find(comm => comm.id === _.toNumber(_.get(item, 'wlCommunityId')));
              item.communityName = community ? community.name : '';
            } else {
              item.communityName = '';
            }
            // 匹配街道名称
            if (!_.isEmpty(this.communityNameArr)) {
              const street = this.communityNameArr.find(str => str.id === _.toNumber(_.get(item, 'wlStreetId')));
              item.streetName = street ? street.name : '';
            } else {
              item.streetName = '';
            }
            return item;
          });
          this.pagination.total = res.data.total || 0;
        }
      } catch (error) {
        console.error('获取设备列表失败：', error);
        this.$message.error("设备数据加载失败，请重试");
      } finally {
        this.loading = false;
      }
    },
    handleCapacityBlur(type) {
      if (type === 'min' && this.searchForm.minCapacity) {
        const value = Number(this.searchForm.minCapacity);
        if (value < 0) {
          this.searchForm.minCapacity = 0;
          this.$message.warning('最小值不能小于0');
        } else if (value > 10) {
          this.searchForm.minCapacity = 10;
          this.$message.warning('最小值不能大于10');
        }
      } else if (type === 'max' && this.searchForm.maxCapacity) {
        const value = Number(this.searchForm.maxCapacity);
        if (value < 0) {
          this.searchForm.maxCapacity = 0;
          this.$message.warning('最大值不能小于0');
        } else if (value > 10) {
          this.searchForm.maxCapacity = 10;
          this.$message.warning('最大值不能大于10');
        }
      }
    },
    handleSearch() {
      this.pagination.pageNo = 1;
      this.getTableData();
    },
    handleReset() {
      this.searchForm = {
        deviceName: '',
        deviceNo: '',
        address: '',
        deviceStatus: '',
        createTime: []
      };
      this.pagination.pageNo = 1;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNo = 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.getTableData();
    },
    async handleDelete(row) {
      this.$confirm('确定要删除该设备吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteWlRecycleDevice(row.id);
          if (res.code === 200) {
            this.$message.success('删除成功');
            this.getTableData();
          } else {
            this.$message.error('删除失败：' + (res.msg || '系统异常'));
          }
        } catch (error) {
          console.error("删除设备失败：", error);
          this.$message.error('删除失败，请重试');
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    async openOrderDialog(row) {
      if (!row) return;
      this.currentDevice = row;
      this.orderDialogVisible = true;
      this.orderPagination.pageNo = 1;
      this.orderFilterType = '';
      await this.getDeviceOrderList();
    },
    async getDeviceOrderList() {
      this.orderLoading = true;
      try {
        const params = {
          deviceId: this.currentDevice.id,
          pageNo: this.orderPagination.pageNo,
          pageSize: this.orderPagination.pageSize
        };
        const res = await getWlRecycleDeviceOrder(params);
        if (res.code === 200) {
          this.orderList = res.data.list || res.data;
          this.orderPagination.total = res.data.total || 0;
        }
      } catch (error) {
        console.error("获取桶内订单失败：", error);
        this.$message.error("订单数据加载失败，请重试");
      } finally {
        this.orderLoading = false;
      }
    },
    handleOrderFilter() {},
    toggleBigMode() {
      this.isBigMode = !this.isBigMode;
    },
    handleOrderSizeChange(val) {
      this.orderPagination.pageSize = val;
      this.orderPagination.pageNo = 1;
      this.getDeviceOrderList();
    },
    handleOrderCurrentChange(val) {
      this.orderPagination.pageNo = val;
      this.getDeviceOrderList();
    },
    previewOrderImage(url) {
      if (!url) {
        this.$message.warning('暂无订单图片');
        return;
      }
      this.orderImageUrl = url;
      this.orderImageVisible = true;
    },
    toDetail(row) {
      if (!row || !row.id) {
        this.$message.warning("设备ID异常，无法查看详情");
        return;
      }
      this.$router.push({
        name: "智能回收机详情",
        params: { id: row.id }
      });
    },
    async openEditDialog(row) {
      this.resetEditForm();
      // 重新获取最新街道列表
      const streetRes = await getStreet();
      this.communityNameArr = streetRes.data || [];
      
      if (row) {
        this.editDialogTitle = '编辑智能回收机';
        this.editForm = {
          id: row.id,
          deviceName: row.deviceName || '',
          deviceNo: row.deviceNo || '',
          address: row.address || '',
          deviceStatus: row.deviceStatus + '',
          usedCapacity: row.usedCapacity || 0,
          userName: row.userName || '',
          longitude: row.longitude || '',
          latitude: row.latitude || '',
          wlStreetId: row.wlStreetId || '',
          wlCommunityId: row.wlCommunityId || '',
          picUrl: row.picUrl || '',
          picUrlList: row.picUrl ? [{ url: row.picUrl }] : []
        };
        // 回显社区：如果有街道ID，获取对应社区
        if (row.wlStreetId) {
          const communityRes = await getCommunity({ wlStreetId: [row.wlStreetId] });
          this.residentialQuartersArr = communityRes.data || [];
        }
      } else {
        this.editDialogTitle = '添加智能回收机';
      }
      this.editDialogVisible = true;
    },
    resetEditForm() {
      this.editForm = {
        id: '',
        deviceName: '',
        deviceNo: '',
        address: '',
        deviceStatus: '',
        usedCapacity: 0,
        userName: '',
        longitude: '',
        latitude: '',
        picUrl: '',
        wlStreetId: '',
        wlCommunityId: '',
        picUrlList: []
      };
      this.residentialQuartersArr = [];
      if (this.$refs.editFormRef) {
        this.$refs.editFormRef.resetFields();
      }
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/');
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片格式（jpg/png/jpeg）！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB！');
        return false;
      }
      return true;
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    async getCommunityList (val) {
      this.editForm.wlCommunityId = "";
      try {
        const { data } = await getCommunity({ wlStreetId: [val] });
        this.residentialQuartersArr = data || [];
      } catch (error) {
        console.error('获取社区列表失败：', error);
        this.$message.warning('社区列表加载失败，请重新选择街道');
        this.residentialQuartersArr = [];
      }
    },
    importFile (file) {
      this.submitStaffBtnBool = true;
      let formData = new FormData();
      formData.append("businessType", 100);
      formData.append("file", file.file, file.file.name);
      uploadAction('/api/upload', formData)
        .then((res) => {
          this.$message.success("上传成功");
          // 修复：更新picUrlList（保持和el-upload的file-list格式一致）
          this.editForm.picUrlList = [{ url: res.data[0] }];
          this.editForm.picUrl = res.data[0];
          this.submitStaffBtnBool = false;
        })
        .catch((err) => {
          this.$message.error("上传失败");
          this.submitStaffBtnBool = false;
        });
    },
    surpass() {
      this.$message.warning('最多只能上传1张设备图片');
    },
    staffImgRemove(file, fileList) {
      this.editForm.picUrlList = fileList;
      this.editForm.picUrl = fileList.length > 0 ? fileList[0].url : '';
    },
    async submitEditForm() {
      try {
        await this.$refs.editFormRef.validate();
        const submitData = {
          ...this.editForm,
          deviceStatus: Number(this.editForm.deviceStatus),
          usedCapacity: Number(this.editForm.usedCapacity),
          picUrl: this.editForm.picUrl
        };
        delete submitData.picUrlList;

        let res;
        if (submitData.id) {
          res = await editWlRecycleDevice(submitData);
        } else {
          res = await addWlRecycleDevice(submitData);
        }

        if (res.code === 200) {
          this.$message.success(submitData.id ? '编辑成功' : '添加成功');
          this.editDialogVisible = false;
          this.getTableData();
        } else {
          this.$message.error(submitData.id ? '编辑失败：' + res.msg : '添加失败：' + res.msg);
        }
      } catch (error) {
        console.error('提交表单失败：', error);
        this.$message.error('表单校验失败，请检查必填项是否填写完整');
      }
    }
  }
};
</script>

<style scoped>
.table-page-container {
  padding: 20px;
  background: #f7f7f7;
  min-height: calc(100vh - 100px);
}

/* 筛选栏响应式核心样式 */
.search-form {
  margin-bottom: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
}
.search-form-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 12px;
}
.form-item {
  margin-bottom: 0 !important;
  margin-right: 15px !important;
}
/* 按钮组在大屏幕靠右，小屏幕全屏宽度 */
.btn-group {
  margin-left: auto !important;
}
@media screen and (max-width: 1200px) {
  .btn-group {
    margin-left: 0 !important;
    width: 100%;
  }
}

/* 订单弹框样式 */
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.order-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 600px;
  overflow-y: auto;
}
.order-list.big-mode {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
}
.order-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.order-list.big-mode .order-card {
  width: calc(50% - 12px);
}
.order-time {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
}
.order-img-placeholder {
  width: 120px;
  height: 80px;
  background: #f8f8f8;
  border-radius: 4px;
  margin-bottom: 16px;
}
.order-info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 32px;
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
}
.info-item {
  display: flex;
  align-items: center;
}
.empty-order {
  padding: 40px 0;
  text-align: center;
}

/* 编辑弹框样式 */
.dialog-footer {
  text-align: right;
}
.el-upload--picture-card {
  width: 100px;
  height: 100px;
}
</style>